



// export default GroupLoanStatus;
import React, { useState, useEffect } from "react";
import axios from "axios";
import "../assets/GroupLoanStatus.css";

const GroupLoanStatus = () => {
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [disburseModal, setDisburseModal] = useState(false);
  const [payDialog, setPayDialog] = useState(false);
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [selectedEmi, setSelectedEmi] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [disbursalDate, setDisbursalDate] = useState(new Date().toISOString().split("T")[0]);
  const [paymentData, setPaymentData] = useState({ amount: "", paidBy: "", paymentMode: "cash", remarks: "" });
  const [paying, setPaying] = useState(false);

  useEffect(() => {
    fetchLoans();
  }, []);

  const fetchLoans = async () => {
    try {
      setLoading(true);
      // const url = `https://narrowitsolution.in/api/group-loan/emi-du?branchId=${localStorage.getItem("userId")}`;
       let url = `https://narrowitsolution.in/api/group-loan/emi-du?superAdminId=${localStorage.getItem(
        "adminuserId"
      )}`;
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
      });
      setLoans(res.data.loans || []);
    } catch (err) {
      console.error("Error fetching group loans:", err);
    } finally {
      setLoading(false);
    }
  };

  // Approve
  const openApproveModal = (loan) => { setSelectedLoan(loan); setRemarks(""); setApproveModal(true); };
  const handleApprove = async () => {
    if (!selectedLoan) return;
    try {
      await axios.post(`https://narrowitsolution.in/api/group-loan/${selectedLoan.id}/approve`, {
        approvedBy: "Cashier Ravi",
        remarks: remarks || "Approved by group account"
      });
      alert(`Loan ${selectedLoan.id} approved successfully!`);
      setApproveModal(false); fetchLoans();
    } catch (err) {
      console.error(err); alert(`Failed to approve loan ${selectedLoan.id}`);
    }
  };

  // Disburse
  const openDisburseModal = (loan) => { setSelectedLoan(loan); setRemarks(""); setDisbursalDate(new Date().toISOString().split("T")[0]); setDisburseModal(true); };
  const handleDisburse = async () => {
    if (!selectedLoan) return;
    try {
      await axios.post(`https://narrowitsolution.in/api/group-loan/${selectedLoan.id}/disbursed`, {
        disbursedBy: "Cashier Ravi",
        disbursalDate,
        remarks: remarks || "Loan amount transferred to group account"
      });
      alert(`Loan ${selectedLoan.id} disbursed successfully!`);
      setDisburseModal(false); fetchLoans();
    } catch (err) {
      console.error(err); alert(`Failed to disburse loan ${selectedLoan.id}`);
    }
  };

  // Open Pay EMI Dialog
  const openPayDialog = (emi, loan) => {
    setSelectedEmi(emi);
    setSelectedLoan(loan);
    setPaymentData({ amount: emi.total, paidBy: "", paymentMode: "cash", remarks: "" });
    setPayDialog(true);
  };

  const handlePayment = async () => {
    if (!selectedEmi || !selectedLoan) return;
    try {
      setPaying(true);
      await axios.post(`https://narrowitsolution.in/api/group-loan/${selectedLoan.id}/pay-emi/${selectedEmi.id}`, paymentData);
      alert(`EMI #${selectedEmi.emiNumber} paid successfully!`);
      setPayDialog(false); fetchLoans();
    } catch (err) {
      console.error(err); alert("Payment failed");
    } finally { setPaying(false); }
  };

  // --- Styles for Pay Dialog ---
  const dialogOverlay = { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999 };
  const dialogBox = { background: "#fff", padding: "20px", borderRadius: "8px", width: "400px", maxWidth: "90%" };
  const inputStyle = { width: "100%", padding: "8px", margin: "5px 0", borderRadius: "4px", border: "1px solid #ccc" };
  const btnStyle = { padding: "8px 16px", border: "none", borderRadius: "4px", cursor: "pointer", background: "#2563eb", color: "#fff" };

  return (
    <div className="loan-status-container">
      <h2>Group Loan Status</h2>
      {loading ? <p>Loading...</p> : loans.length === 0 ? <p>No loans found</p> : (
        <table className="loan-status-table">
          <thead>
            <tr>
              <th>Loan ID</th><th>Scheme</th><th>Centre</th><th>Group</th><th>Principal</th><th>Tenure</th><th>ROI</th><th>Applied Date</th><th>Status</th><th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loans.map((loan) => (
              <tr key={loan.id}>
                <td>{loan.id}</td><td>{loan.schemeName}</td><td>{loan.centreName}</td><td>{loan.groupId}</td>
                <td>₹{loan.principal}</td><td>{loan.tenure} months</td><td>{loan.roi}%</td>
                <td>{new Date(loan.loanAppliedDate).toLocaleDateString()}</td>
                <td><span className={`status-${loan.status}`}>{loan.status}</span></td>
                <td>
                  {loan.status === "applied" && <button onClick={() => openApproveModal(loan)}>Approve</button>}
                  {loan.status === "approved" && <button onClick={() => openDisburseModal(loan)}>Disburse</button>}
                  {loan.status === "disbursed" && loan.emis?.length > 0 && (
                    <button onClick={() => openPayDialog(loan.emis[0], loan)}>Pay EMI</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Approve Modal */}
      {approveModal && (
        <div className="modal-backdrop">
          <div className="modal approve-modal">
            <h3>Approve Loan #{selectedLoan.id}</h3>
            <textarea placeholder="Enter remarks" value={remarks} onChange={(e) => setRemarks(e.target.value)} rows={3} />
            <div className="modal-actions">
              <button onClick={handleApprove}>Approve</button>
              <button onClick={() => setApproveModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Disburse Modal */}
      {disburseModal && (
        <div className="modal-backdrop">
          <div className="modal disburse-modal">
            <h3>Disburse Loan #{selectedLoan.id}</h3>
            <label>Disbursal Date</label>
            <input type="date" value={disbursalDate} onChange={(e) => setDisbursalDate(e.target.value)} />
            <label>Remarks</label>
            <textarea placeholder="Enter remarks" value={remarks} onChange={(e) => setRemarks(e.target.value)} rows={3} />
            <div className="modal-actions">
              <button onClick={handleDisburse}>Disburse</button>
              <button onClick={() => setDisburseModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Pay EMI Dialog */}
      {payDialog && selectedEmi && (
        <div style={dialogOverlay}>
          <div style={dialogBox}>
            <h3>💳 Pay EMI #{selectedEmi.emiNumber}</h3>
            <input type="number" value={paymentData.amount} onChange={(e) => setPaymentData({ ...paymentData, amount: e.target.value })} style={inputStyle} placeholder="Amount" />
            <input type="text" value={paymentData.paidBy} onChange={(e) => setPaymentData({ ...paymentData, paidBy: e.target.value })} style={inputStyle} placeholder="Paid By" />
            <select value={paymentData.paymentMode} onChange={(e) => setPaymentData({ ...paymentData, paymentMode: e.target.value })} style={inputStyle}>
              <option value="cash">Cash</option>
              <option value="bank_transfer">Bank Transfer</option>
              <option value="upi">UPI</option>
            </select>
            <textarea value={paymentData.remarks} onChange={(e) => setPaymentData({ ...paymentData, remarks: e.target.value })} style={inputStyle} placeholder="Remarks" />
            <div style={{ textAlign: "right", marginTop: "10px" }}>
              <button onClick={() => setPayDialog(false)} style={{ ...btnStyle, background: "gray" }}>Cancel</button>
              <button onClick={handlePayment} disabled={paying} style={{ ...btnStyle, marginLeft: "10px" }}>{paying ? "Processing..." : "Confirm Pay"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GroupLoanStatus;
